<template>
  <div :class="classes" :style="{ border: borderStyle }">
    <span>{{ initialMemo }}</span>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'

/** @type {{ size: 'sm' | 'full' }} */
const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'sm'
  }
})

const themeVersion = inject('themeVersion', 'current')

const initialMemo = computed(() => props.text?.slice(0, 1)?.toUpperCase())

const colorScheme = computed(() => {
  if (themeVersion === 'latest') {
    return {
      text: 'szw-text-latest-text-icon-tertiary',
      bg: 'szw-bg-latest-color-disable'
    }
  }

  return {
    text: 'szw-text-text-icon-tertiary szw-text-xxs',
    bg: 'szw-bg-section-static'
  }
})

const borderStyle = computed(() => (themeVersion === 'latest' ? '1px solid #fff' : ''))

const classes = computed(() => {
  const base = 'szw-rounded-full szw-relative szw-row__center szw-items-center'
  let additional = 'szw-h-full szw-w-full'

  if (props.size === 'sm') {
    additional = 'szw-h-5 szw-w-5'
  }

  return [base, additional, colorScheme.value.bg, colorScheme.value.text]
})
</script>
